import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QualitySpec } from '@app/models/analysis.model';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-rubric-card',
    standalone: true,
    imports: [CommonModule, MatCardModule],
    templateUrl: './rubric-card.component.html',
    styleUrls: ['./rubric-card.component.scss'],
})
export class RubricComponent {
    @Input() rubricQualitySpec!: QualitySpec;

    get competenceClass() {
        return this.rubricQualitySpec.qualityLevelLabel === 'Approaching Competence'
            ? 'approaching-competence'
            : this.rubricQualitySpec.qualityLevelLabel === 'Competent'
              ? 'competent'
              : 'not-evident';
    }
}
